import { getConfig } from "@bidbattles/bloks/config";
import { isProduction } from "@bidbattles/bloks/hooks/dev";
import { createFileRoute } from "@tanstack/react-router";
import { notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/devbox")({
	async beforeLoad() {
		if (isProduction(getConfig().env)) {
			throw notFound();
		}
	},
});
